import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-accent-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          准备好开始探索了吗？
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          加入数百万用户的行列，在亚洲一区二区发现精选内容。清晰分区、精准导航，让您的内容之旅更高效。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zone-1"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-accent-600 rounded-full font-label font-semibold text-sm whitespace-nowrap hover:bg-background-100 transition-all duration-300 cursor-pointer"
          >
            探索一区精选
          </Link>
          <Link
            to="/category/zone-2"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-600 text-white rounded-full font-label font-semibold text-sm whitespace-nowrap hover:bg-accent-700 transition-all duration-300 cursor-pointer"
          >
            浏览二区内容
          </Link>
        </div>
      </div>
    </section>
  );
}